const soundAnswer = async(answer) => {
    const path = `../assets/sound/answer/${answer}.mp3`;    
    var audio = new Audio(path);
    audio.play();
}

export default soundAnswer;